import Button from '@material-ui/core/Button';
import React, { useState } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Box } from '~common/components/box.component';
import { TextInput } from '~common/components/form/text-input.component';

export interface Props extends FieldRenderProps<string> {
  allowShowPassword?: boolean;
  autoFocus?: boolean;
}

export const PasswordInput: React.FunctionComponent<Props> = ({ allowShowPassword, ...rest }) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const onMouseDownPassword = (event: React.MouseEvent<HTMLElement>): void => {
    event.preventDefault();
  };

  const onClickShowPassword = (): void => {
    setShowPassword((state: boolean) => !state);
  };

  return (
    <PasswordFieldContainer>
      <TextInput
        fullWidth
        type={showPassword ? 'text' : 'password'}
        autoComplete="current-password"
        {...rest}
      />
      {allowShowPassword && (
        <ShowHideButton
          onClick={onClickShowPassword}
          onMouseDown={onMouseDownPassword}
          disableTouchRipple
          disableRipple
          focusRipple={false}
          size="small"
        >
          {showPassword ? t('login.hidePassword') : t('login.showPassword')}
        </ShowHideButton>
      )}
    </PasswordFieldContainer>
  );
};

export const PasswordFieldContainer = styled(Box)`
  width: 100%;
`;

export const ShowHideButton = styled(Button)`
  && {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 10px;
    font-weight: bold;
    line-height: 14px;
    letter-spacing: 0.8px;
    min-width: 0;
    padding: 0;
  }
  &&,
  &&:hover,
  &&:focus {
    background-color: transparent;
  }
  &&.Mui-focusVisible {
    background: transparent !important;
  }
`;



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/common/src/components/form/password-input.component.tsx